// 倒计时
function getRandomNum(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

let endTimeG;

function cutDownTime() {
  let nowTime = new Date();
  let endTime = new Date(endTimeG);

  let leftTime = endTime.getTime() - nowTime.getTime();
  if (leftTime < 0) {
    setupNewCountdown();
    leftTime = 0;
  }
  let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
    leftM = Math.floor((leftTime / (1000 * 60)) % 60),
    leftS = Math.floor((leftTime / 1000) % 60);
  leftH = leftH >= 10 ? leftH : "0" + leftH;
  leftM = leftM >= 10 ? leftM : "0" + leftM;
  leftS = leftS >= 10 ? leftS : "0" + leftS;

  return {
    hour: leftH,
    minute: leftM,
    second: leftS,
  };
}
function setupNewCountdown() {
  const randomHour = getRandomNum(1, 9);
  const currentTime = new Date();
  endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
}
let intervalId;

function getCutDownTime() {
  setupNewCountdown();
  if (intervalId) clearInterval(intervalId);
  intervalId = setInterval(function () {
    let cutDownTimeText = cutDownTime();
    $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
    $(".sp_top_cut_down .sp_left_view .sp_minute").html(cutDownTimeText.minute);
    $(".sp_top_cut_down .sp_left_view .sp_second").html(cutDownTimeText.second);
  }, 1000);
}

getCutDownTime();

function mainRender() {
  $(function () {
    $("#root").css("zoom", "normal");
    let scale = document.body.clientWidth / 1080;
    $("#root").css("zoom", scale);

    window.addEventListener(
      "resize",
      (function () {
        var timer;
        return function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            let scale = document.body.clientWidth / 1080;
            $("#root").css("zoom", scale);
          }, 100);
        };
      })()
    );
  });

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
    const config = {
      rootMargin: "0px 0px 1300px 0px",
      threshold: 0,
    };

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target;
          const dataSrc = image.getAttribute("data-src");
          image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image); // 停止观察该图片
        }
      });
    },
      config);

    images.forEach(function (image) {
      lazyLoadObserver.observe(image); // 开始观察每个图片
    });
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      });
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  };

  let imgArr = [
    'https://cdn.shopify.com/s/files/1/0665/8899/9906/files/20250614-p1.png',
    'https://cdn.shopify.com/s/files/1/0665/8899/9906/files/20250614-p2.png',
    'https://cdn.shopify.com/s/files/1/0665/8899/9906/files/20250614-p3.png',
    'https://cdn.shopify.com/s/files/1/0665/8899/9906/files/20250614-p4.png',
    'https://cdn.shopify.com/s/files/1/0665/8899/9906/files/20250614-p5.png',
    'https://cdn.shopify.com/s/files/1/0665/8899/9906/files/20250614-p6.png',
    'https://cdn.shopify.com/s/files/1/0665/8899/9906/files/20250614-p7.png',
    'https://cdn.shopify.com/s/files/1/0665/8899/9906/files/20250614-p8.png',
    'https://cdn.shopify.com/s/files/1/0665/8899/9906/files/20250614-p1.png',
    'https://cdn.shopify.com/s/files/1/0665/8899/9906/files/20250614-p2.png',
    'https://cdn.shopify.com/s/files/1/0665/8899/9906/files/20250614-p3.png',
    'https://cdn.shopify.com/s/files/1/0665/8899/9906/files/20250614-p4.png',
    'https://cdn.shopify.com/s/files/1/0665/8899/9906/files/20250614-p5.png',
    'https://cdn.shopify.com/s/files/1/0665/8899/9906/files/20250614-p6.png',
    'https://cdn.shopify.com/s/files/1/0665/8899/9906/files/20250614-p7.png',
    'https://cdn.shopify.com/s/files/1/0665/8899/9906/files/20250614-p8.png',
    'https://cdn.shopify.com/s/files/1/0665/8899/9906/files/20250614-p1.png',
    'https://cdn.shopify.com/s/files/1/0665/8899/9906/files/20250614-p2.png',
    'https://cdn.shopify.com/s/files/1/0665/8899/9906/files/20250614-p3.png',
    'https://cdn.shopify.com/s/files/1/0665/8899/9906/files/20250614-p4.png',
    'https://cdn.shopify.com/s/files/1/0665/8899/9906/files/20250614-p5.png',
    'https://cdn.shopify.com/s/files/1/0665/8899/9906/files/20250614-p6.png',
    'https://cdn.shopify.com/s/files/1/0665/8899/9906/files/20250614-p7.png',
    'https://cdn.shopify.com/s/files/1/0665/8899/9906/files/20250614-p8.png',
  ]

  preloadImages(imgArr)

  new Swiper(".sp-swiper1", {
    speed: 9000,
    autoplay: true,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: "auto",
    spaceBetween: 0,
    loop: true,
  });

  new Swiper("#sp-swiper2", {
    autoplay: {
      disableOnInteraction: false,
      delay: 2500,
    },
    spaceBetween: 0,
    slidesPerView: "auto",
    centeredSlides: true,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });

  let prods = window.product
  function getCur(that){
    let product_con = $(that).closest('.product-part');
    // let style = product_con.find('#sp-style div.active').attr('data-val')
    let color = product_con.find('#sp-color div.active').attr('data-val')
    let size = product_con.find('#sp-size div.active').attr('data-val')
    return prods.filter(item=> item.option2  == color && item.option1 == size)[0]
  }
  function changePrice(that){
    let product_con = $(that).closest('.product-part');
    let num = product_con.find('#calcNumber').val()
    let that1 = that
    let price = (getCur(that1).price * num / 100).toFixed(2)
    let compare = (getCur(that1).compare_at_price * num / 100).toFixed(2)
    // price = (price + '').replace('.', ',')
    // compare = (compare + '').replace('.', ',')
    product_con.find('#sp_price1').html(price)
    product_con.find('#sp_price2').html(compare)
    let off_font = 100 - Math.ceil(getCur(that1).price / getCur(that1).compare_at_price * 100)
    product_con.find(".price-group .sp-row span").html(off_font);
  }

  $(".sp-option").click(function () {
    // 获取当前点击的选项所在的容器
    let container = $(this).closest('.opt-group');
    container.find('.sp-option').removeClass("active");
    $(this).addClass("active");
    let that = this
    changePrice(that)

    // 获取当前容器所在的产品部分（主页面或弹窗）
    let productPart = $(this).closest('.product-part');
    
    // let style = productPart.find(".sp-style .sp-option.active").index();
    let color = productPart.find(".sp-color .sp-option.active").index();
    let size = productPart.find(".sp-size .sp-option.active").index();
    // let _index = style + color * 2 + size * 8;
    let _index =  color * 2 + size * 8;
    
    // 更新当前产品部分的图片
    productPart.find(".sp-img-wrap img.sp-img-p").attr('src', imgArr[_index]);
    
    // 更新数量显示
    let numberElement = productPart.find('.sp-img-wrap .sp-number');
    if (size == 0) {
        numberElement.html('x2');
        numberElement.show();
        $(".product-part .sp-img-wrap .sp-number").css('right', '476px');
        $(".product-part .sp-img-wrap").css('padding-right', '0px');
        $(".product-part .sp-img-wrap .sp-free").css('left', '164px');
    } else if (size == 1) {
        numberElement.html('x4');
        numberElement.show();
        $(".product-part .sp-img-wrap .sp-number").css('right', '512px');
        $(".product-part .sp-img-wrap").css('padding-right', '70px');
        $(".product-part .sp-img-wrap .sp-free").css('left', '130px');
    } else {
        numberElement.html('x4');
        numberElement.show();
        $(".product-part .sp-img-wrap").css('padding-right', '70px');
        $(".product-part .sp-img-wrap .sp-free").css('left', '130px');
    }
});
// ... existing code ...

  $(".sp-reduce").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) - 1;
    let that = this
    if (num > 0) {
      input.value = num;
      changePrice(that)
    }
  });
  $(".sp-add").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) + 1;
    input.value = num;
    let that = this
    changePrice(that)
  });

  $('.sp-btn-style').click(function(){
    let that = this
    let num = $(this).closest('.product-part').find('#calcNumber').val()
    window.location.href = '/cart/' + getCur(that).id + ':' + num
  })

  $(".cart-btn").click(function () {
    $(this).children("img").addClass("on");
    $(".sp-header-top .sp-cart .num").show();
    setTimeout(function () {
      $(".cart-btn").children("img").removeClass("on");
    }, 500);
    $(".sp-header-top .sp-cart").addClass("on");
    setTimeout(function () {
      $(".sp-header-top .sp-cart").removeClass("on");
    }, 500);
  });

  $(".product-part .cart-btn").click(function () {
    $(".sp-cart .num").addClass("sp-gray")
    let that = this
    var data = {
      id: getCur(that).id,
      quantity: $(this).closest('.product-part').find('#calcNumber').val(),
    };
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      success: function () {
        $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
          $("#cardNum").html(result.item_count);
        });
      },
      dataType: "json",
    });
    
    var img = $(this).closest('.product-part').find(".sp-img-wrap img");
    var flyer = img[0].cloneNode(true);
    flyer.classList.add("sp_clone");

    $(this).closest('.product-part').append(flyer);
    $(".sp_clone").css({
      width: img[0].width,
      height: img[0].height,
      position: "fixed",
      top: img[0].offsetTop,
      left: img.offset().left,
      "z-index": "99",
    });

    let finish = $(".sp-cart");
    $(".sp_clone").animate(
      {
        top: finish[0].offsetTop + 20 + $('.time-part').height(),
        left: finish[0].offsetLeft + finish.width() / 3,
        width: 50, // 结束时的大小，根据需要调整
        height: 50, // 结束时的大小，根据需要调整
        opacity: 0.4,
      },
      500,
      "linear",
      function () {
        $(this).animate(
          {
            width: 0,
            height: 0,
            opacity: 0,
          },
          0,
          function () {
            $(this).detach();
          }
        );
      }
    );
  });

  document.addEventListener("DOMContentLoaded", function () {
    lazyLoadImages();

    $('.selectl span').click(function () {
      $(this).addClass("on").siblings().removeClass("on");
    })

    $(".selectl span").click(function () {
      $(this).addClass("on").siblings().removeClass("on");
    });

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        window.scroll({
          top: offsetTop * $("div#root").css("zoom") - 240 * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });
  });

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isAndroid = /android/i.test(userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log("Android");
  } else if (isIOS) {
    console.log("iOS");
  } else if (isPC) {
    console.log("PC");
  } else {
    $(".sp_system").css("letter-spacing", "-4px");
  }



  const tabs = $(".sp-tab");

  let currentIndex = 0; // 当前展示的tab索引

  function nextTabFunc() {
    const currentTab = tabs[currentIndex];
    // 当前tab开始动画
    currentTab.classList.add("sp-tab-ani");

    let nextIndex = (currentIndex + 1) % tabs.length;
    const nextTab = tabs[nextIndex];

    setTimeout(() => {
      currentTab.classList.remove("sp-tab-ani");
    }, 2500);

    currentIndex = (currentIndex + 1) % tabs.length;
    setTimeout(nextTabFunc, 1500);
  }

  // nextTabFunc();



  // 标题文本渐出
  const graduallyList = document.getElementsByClassName("gradually");
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll("span");
    const paragraph = gradually.querySelector(".sp-sub-title");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`;
              span.style.animationDelay = `${index * 0.1}s`;

              const i = span.querySelector("i");
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`;
                i.style.animationDelay = `${index * 0.1}s`;
              }
            });

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3;
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`;
              paragraph.style.animationDelay = `${totalDelay}s`;
            }

            observer.unobserve(gradually);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observer.observe(gradually);
  }



  // 展示尺码弹窗
  $('.sp-btn-pop').click(function () {
    $('.sp-mask').css('display', 'flex')
    // $(".sp-pop").show();
  })
  // 关闭弹窗按钮

  $('.sp-close-btn').click(function (e) {
    $('.sp-mask').hide()
    // $(".sp-pop").hide();
  })



}

mainRender();

